import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  H2,
  PageSubheader,
  PageDescription,
  PageHeader,
} from 'next/components/ui';
import { fetchUserProfile } from 'actions/userProfiles';
import { selectAccountUserProfile } from 'reducers/account/userProfiles';
import { selectAccountMeta } from 'reducers/account/meta';
import {
  IdentifierValue,
  IdentifierName,
  IdentifierListItem,
  IdentifiersListSection,
  IdentifierText,
  ProfileTitle,
} from './styled';
import { SelectIdentifierModalManager } from './SelectIdentifierModal/SelectIdentifierModalManager';

export function Header({
  userId,
  onLoad,
  timestamp,
  userProfileIdentifierValue: identifierValue,
}) {
  useEffect(() => {
    onLoad?.(userId);
  }, [onLoad, userId]);

  const lastSeen =
    moment().diff(timestamp, 'month') >= 1
      ? moment(timestamp).format('llll')
      : moment(timestamp).fromNow();

  return (
    <PageHeader>
      <PageDescription>
        <ProfileTitle>
          <H2>
            User profile
            {identifierValue && (
              <IdentifierText title={identifierValue}>
                {' '}
                - {identifierValue}
              </IdentifierText>
            )}
          </H2>
          <SelectIdentifierModalManager />
        </ProfileTitle>
        <PageSubheader>
          <IdentifiersListSection>
            <IdentifierListItem>
              <IdentifierName>User ID</IdentifierName>
              <IdentifierValue>{userId}</IdentifierValue>
            </IdentifierListItem>

            {timestamp && (
              <IdentifierListItem>
                <IdentifierName>Last seen</IdentifierName>
                <IdentifierValue>{lastSeen}</IdentifierValue>
              </IdentifierListItem>
            )}
          </IdentifiersListSection>
        </PageSubheader>
      </PageDescription>
    </PageHeader>
  );
}

Header.propTypes = {
  userId: PropTypes.number,
  timestamp: PropTypes.number,
  userProfileIdentifierValue: PropTypes.string,
  onLoad: PropTypes.func,
};

const mapStateToProps = (state, { userId }) => {
  const userProfileIdentifier = selectAccountMeta(state)?.userProfileIdentifier;
  const userProfile = selectAccountUserProfile(state, userId);

  return {
    userProfileIdentifierValue: userProfileIdentifier
      ? userProfile?.[userProfileIdentifier]
      : null,

    // eslint-disable-next-line no-underscore-dangle
    timestamp: userProfile?._updatedAt,
  };
};

const mapDispatchToProps = {
  onLoad: fetchUserProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
